import { LabelerTemplate } from "../../labeler/models";
import { Product } from "../models";
import moment from 'moment';

export const getStrTemplateFormatFilled = (strTemplate: string, values: any) => {
    // "LT - ${{LTV}} (${{LTR}}/L)"
    const regexp = /\{\{(?<param>[a-zA-Z0-9]+)\}\}/g;
    const filledString = strTemplate.replace(regexp, function(match, group) {
        console.log(match, group);
        if (values.hasOwnProperty(group)) {
           return values[group];
        }
        return "";
       
    });
    return filledString
}

export const getRawProductPrice = (product: Product, code: string) => {
    if (product && product.prices) {
        if (product.prices.length > 0) {
            const codedPrices = product.prices.filter(p => p.articleCode === code);
            if (codedPrices.length > 0) {
                return codedPrices[0].value;
            }
            const functionToFilterPrices = (p) => {
                if (p.priceList) {
                  if (Number(p.priceList.number) === 1) {
                    return p
                  }
                }
              }
              const pricesWithLowerNumberLength = product.prices.filter(//find price list with number == 1
                p => functionToFilterPrices(p)
      
              );
              const functionToFilterGreaterThanDateNow = (p) => {
                const myDate = new Date()
                const currentDate = moment(myDate)
                const dateToCompare = moment(p.validFrom)
                if (dateToCompare.isBefore(currentDate)) {
                  return true
                }
              }
              console.log("prices with Lowernumber",pricesWithLowerNumberLength)
              const pricesEarlierThanCurrentDate = pricesWithLowerNumberLength.filter(
                p => functionToFilterGreaterThanDateNow(p)
      
              )
              console.log("prices sorted by date",pricesEarlierThanCurrentDate)
              
              let pricesSortedByDate = []
              pricesSortedByDate = pricesEarlierThanCurrentDate


            //let pricesSortedByDate = [...product.prices];
            if (pricesSortedByDate.length > 1){
                pricesSortedByDate.sort((a, b) => {
                    const momentA = moment(a.validFrom);
                    const momentB = moment(b.validFrom);
                    if (momentA.isAfter(momentB)) {
                        return -1;
                    } else if (momentA.isBefore(momentB)) {
                        return 1;
                    }
                    return 0;
                });
            }
            console.log("~~~~~~~~~~~~~~~~~~~~~~~~~~~~", pricesSortedByDate)
            return pricesSortedByDate && pricesSortedByDate.length > 0 ? pricesSortedByDate[0].value : 0;
        }
    }
    return 0;
};

export const getProductPriceFormatted = (product: Product, code: string, selectedTemplate: LabelerTemplate=null, format: any=null, removeSign=false) => {
    // console.log("selectedTemplate", JSON.stringify(selectedTemplate));
    let priceTemplateField = null;
    if (selectedTemplate) {
        priceTemplateField = selectedTemplate.content.labelFields && selectedTemplate.content.labelFields.find(l => l.name === 'PRODUCTREGULARPRICE');
    }
    console.log("priceTemplateField", priceTemplateField);
    let priceFormat = priceTemplateField && priceTemplateField.hasOwnProperty("format") ? priceTemplateField.format : format;
    const noCurrency = priceTemplateField && priceTemplateField.hasOwnProperty("noCurrency") ? priceTemplateField.noCurrency : removeSign;
    if (noCurrency) {
        removeSign = true
    }
    
    const price = getRawProductPrice(product, code);
    let priceString = Number(price).toFixed(2);
    console.log("getting formatted price", price, priceFormat, removeSign);
    if (priceFormat) {
        let values = {
            PRODUCTREGULARPRICE: priceString,
        }
        let formattedString = getStrTemplateFormatFilled(priceFormat, values);
        console.log("getting formatted price", formattedString);
        return formattedString;
    } else {
        if (removeSign) {
            return `${priceString}`;
        } else {
            return `$${priceString}`
        }
    }
    
};

export const getGrossPriceFormatted = (grossPrice: any, selectedTemplate: LabelerTemplate=null, format: any=null, removeSign=false) => {
    let grossPriceTemplateField = null;
    if (selectedTemplate) {
        grossPriceTemplateField = selectedTemplate.content.labelFields && selectedTemplate.content.labelFields.find(l => l.name === 'PRODUCTGROSSPRICE')
    }
    let grossPriceFormat = grossPriceTemplateField && grossPriceTemplateField.hasOwnProperty("format")  ? grossPriceTemplateField.format : format;
    let grossPriceNoCurrency = grossPriceTemplateField && grossPriceTemplateField.hasOwnProperty("noCurrency") ? grossPriceTemplateField.noCurrency : removeSign;
    console.log("getting formatted gross price", grossPrice, format, removeSign);
    let grossPriceString = Number(grossPrice).toFixed(2);
    
    if (grossPriceFormat) {
        let values = {
            PRODUCTGROSSPRICE: grossPriceString,
        }
        let formattedString = getStrTemplateFormatFilled(grossPriceFormat, values);
        console.log("getting formatted gross price", formattedString);
        return formattedString;
    } else {
        if (!grossPriceNoCurrency) {
            grossPriceString = '$' + grossPriceString;
        }
        let formattedString = grossPriceString;
        console.log("getting gross price", formattedString);
        return formattedString;
    }
}

export const getLiterTaxFormatted = (taxAmount: any, literTaxRate: any, selectedTemplate: LabelerTemplate=null, format: any=null, removeSign=false) => {
    let literTaxTemplateField = null;
    if (selectedTemplate) {
        literTaxTemplateField = selectedTemplate.content.labelFields && selectedTemplate.content.labelFields.find(l => l.name === 'PRODUCTLITERTAX')
    }
    let literTaxFormat = literTaxTemplateField && literTaxTemplateField.hasOwnProperty("format")  ? literTaxTemplateField.format : format;
    let literTaxNoCurrency = literTaxTemplateField && literTaxTemplateField.hasOwnProperty("noCurrency") ? literTaxTemplateField.noCurrency : removeSign;
    console.log("getting formatted liter tax", taxAmount, literTaxRate, format, removeSign);
    let literTaxString = Number(taxAmount).toFixed(2);
    let literTaxRateString = Number(literTaxRate).toFixed(2);
    
    if (literTaxFormat) {
        let values = {
            PRODUCTLITERTAXVALUE: literTaxString,
            PRODUCTLITERTAXRATE: literTaxRateString
        }
        let formattedString = getStrTemplateFormatFilled(literTaxFormat, values);
        console.log("getting formatted liter tax", formattedString);
        return formattedString;
    } else {
        if (!literTaxNoCurrency) {
            literTaxString = '$' + literTaxString;
        }
        let formattedString = literTaxString;
        console.log("getting liter tax", formattedString);
        return formattedString;
    }
}



export const getLiterTax = (product: Product, literTaxUUID: any) => {
    if (!literTaxUUID) {
        console.log("no liter tax uuid")
        return {taxAmount: 0, literTaxRate: 0};
    }
    
      if (product.hasOwnProperty('sub_items') && product.sub_items.length > 0) {
        let liter_tax_item = product.sub_items.filter(si => si.sub_product.uuid == literTaxUUID);
        if (liter_tax_item.length > 0) {
          liter_tax_item = liter_tax_item[0];
          if (liter_tax_item.prices.length > 0) {
            
            const functionToFilterGreaterThanDateNow = (p) => {
              const myDate = new Date()
              const currentDate = moment(myDate)
              const dateToCompare = moment(p.validFrom)
              if (dateToCompare.isBefore(currentDate)) {
                return true
              }
            }
    
            const pricesEarlierThanCurrentDate = liter_tax_item.prices.filter(
              p => functionToFilterGreaterThanDateNow(p)
    
            )
    
            let pricesSortedByDate = []
            pricesSortedByDate = pricesEarlierThanCurrentDate
            pricesSortedByDate.sort((a, b) => {
              const momentA = moment(a.validFrom);
              const momentB = moment(b.validFrom);
              if (momentA.isAfter(momentB)) {
                return -1;
              } else if (momentA.isBefore(momentB)) {
                return 1;
              }
              return 0;
            });
            const priceVal = pricesSortedByDate[0].value;
            let grossPriceVal = priceVal * liter_tax_item.quantity;
            
            return {taxAmount: grossPriceVal, literTaxRate: priceVal};
          } else return  {taxAmount: 0, literTaxRate: 0};
        } else {
            console.log("no liter tax sub item")
          // dont have the liter tax sub item
          return {taxAmount: 0, literTaxRate: 0};
        }
      }
    console.log("no sub item")
    return {taxAmount: 0, literTaxRate: 0};
}

export const getSalesTaxFormatted = (taxAmount: any, salesTaxRate: any, selectedTemplate: LabelerTemplate=null, format: any=null, removeSign=false) => {
    let salesTaxTemplateField = null;
    if (selectedTemplate) {
        salesTaxTemplateField = selectedTemplate.content.labelFields && selectedTemplate.content.labelFields.find(l => l.name === 'PRODUCTSALESTAX')
    }
    let salesTaxFormat = salesTaxTemplateField && salesTaxTemplateField.hasOwnProperty("format") ? salesTaxTemplateField.format : format;
    let salesTaxNoCurrency = salesTaxTemplateField && salesTaxTemplateField.hasOwnProperty("noCurrency") ? salesTaxTemplateField.noCurrency : removeSign;

    console.log("getting formatted sales tax", taxAmount, salesTaxRate, format, removeSign);
    let salesTaxString = Number(taxAmount).toFixed(2);
    let salesTaxRateString = Number(salesTaxRate).toFixed(2);
    
    if (salesTaxFormat) {
        let values = {
            PRODUCTSALESTAXVALUE: salesTaxString,
            PRODUCTSALESTAXRATE: salesTaxRateString
        }
        let formattedString = getStrTemplateFormatFilled(salesTaxFormat, values);
        console.log("getting formatted sales tax", formattedString);
        return formattedString;
    } else {
        if (!salesTaxNoCurrency) {
            salesTaxString = '$' + salesTaxString;
        }
        let formattedString = salesTaxString;
        console.log("getting sales tax", formattedString);
        return formattedString;
    }
}
export const getSalesTax = (product: Product, productPrice: number) => {
    if (product && product.sector) {
        const sector = product.sector;
        if (sector.tax && sector.tax.length > 0) {
        const totalTaxAmounts = sector.tax.map((tax) => {
            const rate = tax.latest_rate.rate;
            const taxAmount = productPrice * (rate/100.0);
            return {taxAmount, rate};
        });
        console.log("totalTaxAmounts", totalTaxAmounts);
        const totalTaxRate = totalTaxAmounts.map(a => a.rate).reduce((a, b) => {return a + b});
        const totalTaxAmount = totalTaxAmounts.map(a => a.taxAmount).reduce((a, b) => {return a + b});
        console.log("totalTaxAmount", totalTaxAmount);
        return {taxAmount: totalTaxAmount, salesTaxRate: totalTaxRate};
        }
    }
    return {taxAmount: 0, salesTaxRate: 0};
}

export const getProductNameForLabel = (product: Product) => {
    let productName = product.name;
    if (product.article_texts && product.article_texts.length > 0) {
        const labelTexts = product.article_texts.filter(t => t.type === 'ARTICLETEXT_LABEL_TEXT');
        if (labelTexts.length > 0) {
            productName = labelTexts[0].text;
        }
    }
    return productName;
};

export const getProductNameForLabelFormatted = (product: Product, selectedTemplate: LabelerTemplate=null, format: any=null) => {
    let nameTemplateField = null;
    if (selectedTemplate) {
        nameTemplateField = selectedTemplate.content.labelFields && selectedTemplate.content.labelFields.find(l => l.name === 'PRODUCTNAME')
    }
    let nameFormat = nameTemplateField && nameTemplateField.hasOwnProperty("format") ? nameTemplateField.format : format;
    let name = getProductNameForLabel(product);
    if (nameFormat) {
        let values = {
            PRODUCTNAME: name,
        }
        let formattedString = getStrTemplateFormatFilled(nameFormat, values);
        console.log("getting formatted name", formattedString);
        return formattedString;
    } else {
        return name;
    }
}

export const getCommodityGroupNameFormatted = (product: Product, selectedTemplate: LabelerTemplate=null, format: any=null) => {
    let cgNameTemplateField = null;
    if (selectedTemplate) {
        cgNameTemplateField = selectedTemplate.content.labelFields && selectedTemplate.content.labelFields.find(l => l.name === 'COMMODITYGROUPNAME')
    }
    let nameFormat = cgNameTemplateField && cgNameTemplateField.hasOwnProperty("format") ? cgNameTemplateField.format : format;
    let cgName = product.commodityGroup.name;
    if (nameFormat) {
        let values = {
            COMMODITYGROUPNAME: cgName,
        }
        let formattedString = getStrTemplateFormatFilled(nameFormat, values);
        console.log("getting formatted name", formattedString);
        return formattedString;
    } else {
        return cgName;
    }
}

export const getCommodityGroupNumberFormatted = (product: Product, selectedTemplate: LabelerTemplate=null, format: any=null) => {
    let cgNumberTemplateField = null;
    if (selectedTemplate) {
        cgNumberTemplateField = selectedTemplate.content.labelFields && selectedTemplate.content.labelFields.find(l => l.name === 'COMMODITYGROUPNUMBER')
    }
    let nameFormat = cgNumberTemplateField && cgNumberTemplateField.hasOwnProperty("format") ? cgNumberTemplateField.format : format;
    let cgNumber = product.commodityGroup.number;
    if (nameFormat) {
        let values = {
            COMMODITYGROUPNUMBER: cgNumber,
        }
        let formattedString = getStrTemplateFormatFilled(nameFormat, values);
        console.log("getting formatted name", formattedString);
        return formattedString;
    } else {
        return cgNumber;
    }
}


export const getProductPriceByPriceGroup = (product: Product, code: string, removeSign: boolean) => {
    if (product && product.prices) {
        if (product.prices.length > 0) {
            const codedPrices = product.prices.filter(p => p.articleCode === code);
            if (codedPrices.length > 0) {
                return codedPrices[0].value.toString();
            }

            const distinctPriceGroups = [... new Set(product.prices.map(x=>(x.priceList != null) ? x.priceList.number: null))].filter(x=>x !=null)
            
            const finalPrices = distinctPriceGroups.sort().map(dp=>{
                const functionToFilterGreaterThanDateNow = (p) => {
                    const myDate = new Date()
                    const currentDate = moment(myDate)
                    const dateToCompare = moment(p.validFrom)
                    if (dateToCompare.isBefore(currentDate)) {
                        return true
                    }
                }
                // console.log("prices with Lowernumber", pricesWithLowerNumberLength)
                const pricesEarlierThanCurrentDate = product.prices.filter(
                    p => {
                        if (p.priceList) {
                            if (Number(p.priceList.number) === Number(dp)) {
                                return functionToFilterGreaterThanDateNow(p)
                            }
                        }
                    }
                )
                // console.log("prices sorted by date", pricesEarlierThanCurrentDate)
    
                let pricesSortedByDate = []
                pricesSortedByDate = pricesEarlierThanCurrentDate
                // console.log("pricesSortedByDate~b4",pricesSortedByDate)
    
                //let pricesSortedByDate = [...product.prices];
                if (pricesSortedByDate.length > 1) {

                    pricesSortedByDate.sort((a, b) => {
                        const momentA = moment(a.validFrom);
                        const momentB = moment(b.validFrom);
                        if (momentA.isAfter(momentB)) {
                            return -1;
                        } else if (momentA.isBefore(momentB)) {
                            return 1;
                        }
                        return 0;
                    });
                }
                // console.log("pricesSortedByDate",pricesSortedByDate[0])
                return pricesSortedByDate[0].value.toString();

            })
            
            let prices = []
            for (let p in finalPrices) {
                prices.push('$' + `${finalPrices[p]}`)
            }
            
            if(finalPrices.length < 3){
                let diff = (3 - finalPrices.length)
                let count = 0
                for (let i=0; i<diff; i++){
                    prices.push('$0.00')
                }
            }

            return prices
        }
    }
    return '0.00';
};